'use client';

import { useRouter } from 'next/navigation';
import * as React from 'react';
import { encodePassphrase, generateRoomId, randomString } from '@/lib/client-utils';
import { Brand } from '@/lib/Brand';
import { ParticleWave } from '@/lib/ParticleWave';

export default function Page() {
  const router = useRouter();
  const [e2ee, setE2ee] = React.useState(false);
  const [passphrase] = React.useState(() => randomString(64));

  const start = () => {
    const id = generateRoomId();
    router.push(e2ee ? `/rooms/${id}#${encodePassphrase(passphrase)}` : `/rooms/${id}`);
  };

  return (
    <main
      data-lk-theme="default"
      style={{
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        background: 'radial-gradient(120% 90% at 50% -10%, #14161f 0%, #07080c 55%, #050609 100%)',
      }}
    >
      {/* grid técnico sutil ao fundo */}
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.6,
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)',
          backgroundSize: '48px 48px',
          WebkitMaskImage: 'radial-gradient(70% 60% at 50% 28%, #000, transparent)',
          maskImage: 'radial-gradient(70% 60% at 50% 28%, #000, transparent)',
        }}
      />

      {/* HERO */}
      <div
        style={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '56px 24px 8px',
          textAlign: 'center',
        }}
      >
        <Brand size="lg" style={{ marginBottom: 30 }} />

        <h1
          style={{
            margin: 0,
            fontSize: 'clamp(34px, 6vw, 62px)',
            fontWeight: 800,
            lineHeight: 1.04,
            letterSpacing: '-0.03em',
            color: '#f3f6fb',
            maxWidth: '15ch',
          }}
        >
          Construa software{' '}
          <span
            style={{
              backgroundImage: 'linear-gradient(90deg, #9a8bff, #5ac8ff, #ff8a3d)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
            }}
          >
            conversando
          </span>
          .
        </h1>

        <p
          style={{
            margin: '20px 0 0',
            fontSize: 'clamp(15px, 1.6vw, 18px)',
            color: '#9aa6b6',
            maxWidth: '54ch',
            lineHeight: 1.55,
          }}
        >
          Fale o que você precisa. A gente entende, projeta e constrói o seu sistema —
          do discovery à fábrica do MakeStudio.
        </p>

        <button
          type="button"
          onClick={start}
          style={{
            marginTop: 32,
            padding: '15px 34px',
            borderRadius: 14,
            border: 'none',
            fontSize: 16,
            fontWeight: 700,
            color: '#06141f',
            cursor: 'pointer',
            background: 'linear-gradient(180deg, #7fd2ff, #34a8ff)',
            boxShadow: '0 12px 34px rgba(52,168,255,0.34)',
            transition: 'transform 0.16s ease, box-shadow 0.16s ease, filter 0.16s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.filter = 'brightness(1.06)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.filter = 'none';
          }}
        >
          Iniciar Discovery
        </button>

        <label
          style={{
            marginTop: 18,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 12.5,
            color: '#7e8a9a',
            cursor: 'pointer',
          }}
        >
          <input type="checkbox" checked={e2ee} onChange={(ev) => setE2ee(ev.target.checked)} />
          Ativar criptografia ponta-a-ponta
        </label>
      </div>

      {/* ONDA assinatura (a voz virando forma) */}
      <div
        style={{
          position: 'relative',
          marginTop: -10,
          WebkitMaskImage: 'linear-gradient(180deg, transparent, #000 28%, #000)',
          maskImage: 'linear-gradient(180deg, transparent, #000 28%, #000)',
        }}
      >
        <ParticleWave height={300} />
      </div>
    </main>
  );
}
